 document.addEventListener('DOMContentLoaded', function() {
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const hiddenBlocks = document.querySelectorAll('.u-review-box.uhidden');

    loadMoreBtn.addEventListener('click', function() {
      hiddenBlocks.forEach(function(block) {
        block.classList.remove('uhidden');
      });
      loadMoreBtn.style.display = 'none';
    });
  });